angular.module('picmonicng').directive('functionOnShiftEnter', function () {
  return function (scope, element, attrs) {
    element.bind('keypress', function (event) {
      if (event.which === 13 && event.shiftKey) {
        scope.$apply(function () {
          scope.$eval(attrs.functionOnShiftEnter, { event: event });
        });

        event.preventDefault();
      }
    });
  };
});
